const gykz = [
  {
    path: 'gykz_gykzjh',
    name: 'gykz_gykzjh',
    component: () =>
      import('@/components/gykz/gykzjh'),
    meta: { title: '智能巡检计划', requireAuth: true, keepAlive: true, permission: true }
  },
  {
    path: 'gykz_gykzrw',
    name: 'gykz_gykzrw',
    component: () =>
      import('@/components/gykz/gykzrw'),
    meta: { title: '智能巡检任务', requireAuth: true, keepAlive: true, permission: true }
  },
  {
    path: 'gykz_gykztz',
    name: 'gykz_gykztz',
    component: () =>
      import('@/components/gykz/gykztz'),
    meta: { title: '智能巡检台账', requireAuth: true, keepAlive: true, permission: true }
  }
]
export default gykz



// WEBPACK FOOTER //
// ./src/router/gykz.js